import Link, { LinkTheme } from 'components/link/Link';
import Heading from 'components/heading/Heading';
import LinkList from 'components/link-list/LinkList';

import { ILink, INestedLink } from 'source/NFR.types';

interface NestedLinkProps extends INestedLink {
  linkTheme: LinkTheme | LinkTheme[];
}

const NestedLink: React.FC<NestedLinkProps> = ({
  item,
  // iconData,
  linkTheme
}) =>
  item.items ? (
    <li className="nested-link--list">
      {item.title && <Heading className="nested-link--title">{item.title}</Heading>}
      <LinkList
        items={item.items}
        linkTheme={!item.isSmall ? ['actionLink', 'large'] : 'actionLink'}
        onPageEditing={{ items: '' }}
        theme="portfolio"
        withIcon
      />
    </li>
  ) : (
    <li className="nested-link--link">
      <Link theme={linkTheme} {...(item as ILink)} />
    </li>
  );

NestedLink.displayName = 'NestedLink';

export default NestedLink;
